import React, { useState } from 'react';

interface EmojiPickerProps {
  onEmojiSelect: (emoji: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ onEmojiSelect, isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState<'emoji' | 'sticker'>('emoji');
  
  // Emojis agrupados por categoria
  const emojis = {
    smileys: ['😀', '😂', '🥰', '😎', '🤩', '😍', '🤗', '😋', '😜', '🤪'],
    animals: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯'],
    food: ['🍎', '🍕', '🍔', '🍟', '🍦', '🍩', '🍪', '🍫', '🍿', '🍺'],
    activities: ['⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🎱', '🏓', '🏸', '🥊'],
    travel: ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚐'],
    objects: ['⌚', '📱', '💻', '⌨', '🖥', '🖨', '🖱', '🖲', '🕹', '🗜']
  };

  // Stickers fictícios (em um projeto real, seriam imagens)
  const stickers = [
    { id: 1, name: 'Thumbs Up', emoji: '👍' },
    { id: 2, name: 'Heart', emoji: '❤️' },
    { id: 3, name: 'Fire', emoji: '🔥' },
    { id: 4, name: 'Laughing', emoji: '🤣' },
    { id: 5, name: 'Cool', emoji: '😎' },
    { id: 6, name: 'Crying', emoji: '😂' },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-md w-full p-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-white">Emojis & Stickers</h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            ✕
          </button>
        </div>
        
        <div className="flex border-b border-gray-700 mb-4">
          <button
            className={`flex-1 py-2 font-semibold ${activeTab === 'emoji' ? 'text-yellow-400 border-b-2 border-yellow-400' : 'text-gray-400'}`}
            onClick={() => setActiveTab('emoji')}
          >
            Emojis
          </button>
          <button
            className={`flex-1 py-2 font-semibold ${activeTab === 'sticker' ? 'text-yellow-400 border-b-2 border-yellow-400' : 'text-gray-400'}`}
            onClick={() => setActiveTab('sticker')}
          >
            Stickers
          </button>
        </div>
        
        <div className="max-h-60 overflow-y-auto">
          {activeTab === 'emoji' ? (
            <div className="grid grid-cols-6 gap-2">
              {Object.entries(emojis).map(([category, emojiList]) => (
                <React.Fragment key={category}>
                  {emojiList.map((emoji, index) => (
                    <button
                      key={`${category}-${index}`}
                      onClick={() => onEmojiSelect(emoji)}
                      className="text-2xl p-2 hover:bg-gray-700 rounded-lg"
                    >
                      {emoji}
                    </button>
                  ))}
                </React.Fragment>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-3 gap-3">
              {stickers.map((sticker) => (
                <button
                  key={sticker.id}
                  onClick={() => onEmojiSelect(sticker.emoji)}
                  className="flex flex-col items-center p-3 hover:bg-gray-700 rounded-lg"
                >
                  <span className="text-3xl mb-1">{sticker.emoji}</span>
                  <span className="text-xs text-gray-400">{sticker.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};